import { MethodEnum } from '@enum/method.enum';
import { isExist } from '@util/data/is-exist';

import { CodeTag } from './code-method.style';

interface CodeMethodProps {
  method?: MethodEnum;
  small?: boolean;
}

export const CodeMethod = ({ method, small = false }: CodeMethodProps) => {
  if (!isExist(method)) return null;

  let color = 'success';

  if (method === MethodEnum.POST) color = 'processing';
  if (method === MethodEnum.PUT || method === MethodEnum.PATCH) color = 'warning';
  if (method === MethodEnum.DELETE) color = 'error';

  return (
    <CodeTag color={color} small={small}>
      {method}
    </CodeTag>
  );
};
